import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    margin: 20px 0;\n    height: 1px;\n    background-color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
export var Divider = styled.div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.gray.gray200;
});